import { glossary } from '../../store';

export function openGlossary() {
  glossary.open.set(true);
}
